import React, { useEffect, useRef } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import CloseIcon from '@mui/icons-material/Close';
import { useCloseable } from '@nhl/react-hooks/lib/useCloseable';

import { filterActionCreators } from '~/redux/ducks/playersAndTeams/filter';
import { commonMessages } from '~/utility/commonMessages';

import { ClearFilterButton, SubmitButton } from '../buttons';

import ColumnContainer from './columnContainer';
import CountrySelect from './countrySelect';
import CustomFilters from './customFilters';
import DecisionSelect from './decisionSelect';
import DraftRoundSelect from './draftRoundSelect';
import DraftYearSelect from './draftYearSelect';
import ExpSelect from './expSelect';
import HandDominanceSelect from './handDominanceSelect';
import LocationSelect from './locationSelect';
import OpponentSelect from './opponentSelect';
import PlayerSearch from './playerSearch';
import StateOrProvinceSelect from './stateOrProvinceSelect';
import StatusSelect from './statusSelect';

import { FilterActionContainer, DialogContainer, FilterHeader, FiltersContainer } from './styles';

const Filters = () => {
    const dispatch = useDispatch();
    const dialogRef = useRef();
    const intl = useIntl();

    const isVisible = useSelector((state) => state.playersAndTeams.filter.isVisible);
    const reportCategory = useSelector((state) => state.playersAndTeams.report.reportCategory);

    const handleClose = () => {
        dialogRef.current?.close();
        dispatch(filterActionCreators.setFiltersVisibility(false));
    };

    useCloseable({ closeableRef: dialogRef, closeFunction: handleClose, shouldStopListening: !isVisible });

    useEffect(() => {
        if (isVisible) {
            dialogRef.current?.showModal();
        }
    }, [isVisible]);

    return (
        <>
            <DialogContainer $isVisible={isVisible} />
            <FiltersContainer $isVisible={isVisible} ref={dialogRef}>
                <FilterHeader>
                    <h4 aria-level={3}>
                        <FormattedMessage {...commonMessages.labels.advanced} />
                    </h4>
                    <CloseIcon onClick={handleClose} />
                </FilterHeader>

                {reportCategory !== 'team' && <PlayerSearch />}

                {reportCategory === 'team' ? (
                    <ColumnContainer title={intl.formatMessage(commonMessages.labels.gameDetails)}>
                        <LocationSelect />
                        <DecisionSelect />
                        <OpponentSelect />
                    </ColumnContainer>
                ) : (
                    <>
                        <ColumnContainer title={intl.formatMessage(commonMessages.advancedFilters.experienceAndStatus)}>
                            <ExpSelect />
                            <StatusSelect />
                        </ColumnContainer>
                        <ColumnContainer title={intl.formatMessage(commonMessages.labels.origin)}>
                            <CountrySelect />
                            <StateOrProvinceSelect />
                        </ColumnContainer>
                        <ColumnContainer title={intl.formatMessage(commonMessages.labels.gameDetails)}>
                            <LocationSelect />
                            <DecisionSelect />
                            <OpponentSelect />
                        </ColumnContainer>
                        <ColumnContainer title={intl.formatMessage(commonMessages.labels.draftDetails)}>
                            <DraftYearSelect />
                            <DraftRoundSelect />
                        </ColumnContainer>
                        <ColumnContainer
                            title={intl.formatMessage(
                                reportCategory === 'skater'
                                    ? commonMessages.filters.shoots
                                    : commonMessages.filters.catches,
                            )}
                        >
                            <HandDominanceSelect />
                        </ColumnContainer>
                    </>
                )}
                <CustomFilters />
                <FilterActionContainer $isVisible={isVisible}>
                    <ClearFilterButton />
                    <SubmitButton handleClose={handleClose} />
                </FilterActionContainer>
            </FiltersContainer>
        </>
    );
};

export default React.memo(Filters);
